<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="zoom-control-container" [ngClass]="styleClass">
	<div (click)="zoomIn()" class="stupid-safari-11 no-print button-sm--square zoom-control-button">+</div>
	<!-- <div class="divider no-print"></div> -->
	<div (click)="zoomOut()" class="stupid-safari-11 no-print button-sm--square zoom-control-button">-</div>
	<!-- <div class="divider no-print"></div> -->
	<div (click)="seeAll()" class="stupid-safari-11 no-print button-sm--square zoom-control-button">
		<i class="material-icons notranslate no-print">all_out</i>
	</div>
</div>
